import clsx from 'clsx';
import React, { useState } from 'react';
import { toggleSwitch } from '../../reducers/switch';
import ToggleIcon from '../../assets/icons/sidebar-toggle-icon.svg?react';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/Button';
import ChevronIcon from '../../assets/icons/chevron-down-icon.svg?react';
import PlusIcon from '../../assets/icons/add-icon.svg?react';
import EditIcon from '../../assets/icons/edit-icon.svg?react';
import SidebarCrossIcon from '../../assets/icons/sidebar-cross-icon.svg?react';
import TextArea from '../../components/TextArea';
import ModalComponent from '../../components/ModalComponent';
import InvestigationReportingAddQuestionModal from '../../components/InvestigationReportingAddQuestionModal';
import { toggleModal } from '../../reducers/modalToggle';
import {
  Attachments,
  InvestigationQuestionWithCategory,
} from '@EHSNavigator/backend';
import InvestigationReportingDeleteQuestionModal from '../../components/InvestigationReportingDeleteQuestionModal';
interface InvestigationReportingStepFourProps {
  otherClasses?: string;
  formHandler: any;
  handleNextStep: (steps: number) => void;
  questions: InvestigationQuestionWithCategory[];
  attachments: Attachments[];
}

const InvestigationReportingStepFour: React.FC<
  InvestigationReportingStepFourProps
> = ({ otherClasses, formHandler, handleNextStep, questions, attachments }) => {
  const investigationReportingStepFourClasses = clsx(otherClasses);
  const sm = useButtonSizeSmall();
  const dispatch = useDispatch();
  const [selectedQuestion, setSelectedQuestion] = useState<any>(null);
  const modalName = useSelector(
    (state: { modalToggle: { modalName: string } }) =>
      state.modalToggle.modalName,
  );

  return (
    <div
      className={investigationReportingStepFourClasses}
      data-testid="investigation-reporting-step-four"
    >
      <div className="flex flex-row items-start gap-2.5">
        <button
          type="button"
          className="bg-translucent-background/80 border-neutral-tones-text/30 rounded-5 w-fit cursor-pointer border p-0.5 lg:hidden"
          onClick={() => dispatch(toggleSwitch())}
        >
          <ToggleIcon />
        </button>
        <div className="flex flex-col gap-1">
          <span className="text-brand-byzantine font-inter-variable text-xs leading-4 font-bold lg:hidden">
            INJURY/ILLNESS
          </span>
          <h4 className="text-neutral-tones-text font-inter-variable font-bold">
            Summing It All Up
          </h4>
          <p className="text-brand-byzantine font-inter-variable text-base leading-5 font-bold lg:mt-15">
            STEP{' '}
            {formHandler?.values?.files?.length > 0 || attachments?.length > 0
              ? 3
              : questions?.length > 0
                ? 4
                : 3}{' '}
            /{' '}
            {formHandler?.values?.files?.length > 0 || attachments?.length > 0
              ? 4
              : questions?.length > 0
                ? 5
                : 4}
          </p>
        </div>
      </div>

      <div className="border-neutral-tones-text mt-8 mb-9 border-y py-9 lg:my-9">
        {formHandler?.values?.files?.length > 0 || attachments?.length > 0 ? (
          <>
            <div className="flex flex-col">
              <h6 className="text-brand-papery font-inter-variable mb-2.5 text-base leading-5 font-bold uppercase lg:text-xl lg:leading-6">
                Uploaded Files
              </h6>
              <div className="flex flex-col gap-2">
                {formHandler?.values?.files?.map((att: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className={clsx(
                        'bg-additional-dropdown-select/10 ring-brand-byzantine flex w-full items-center justify-between rounded-md px-15 py-2 ring',
                      )}
                    >
                      <div className="flex items-center gap-2.5">
                        <p className="text-form-label text-neutral-tones-text -tracking-form-label leading-4 font-bold">
                          {att.name}
                        </p>
                      </div>
                    </div>
                  );
                })}
                {attachments?.map((att) => {
                  return (
                    <div
                      key={att.id}
                      className={clsx(
                        'bg-additional-dropdown-select/10 ring-brand-byzantine flex w-full items-center justify-between rounded-md px-15 py-2 ring',
                      )}
                    >
                      <div className="flex items-center gap-2.5">
                        <p className="text-form-label text-neutral-tones-text -tracking-form-label leading-4 font-bold">
                          {att.name}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        ) : (
          <div className="rounded-10 bg-card-backgrounds/5 border-neutral-tones-text/10 flex flex-wrap items-center gap-x-2.5 gap-y-6 border p-5">
            {formHandler?.values?.otherQuestions?.length > 0 ? (
              <div className="global-scrollbar-style w-full overflow-auto pb-4">
                <div className="w-full min-w-3xl">
                  <div className="border-neutral-tones-text/10 mb-3 grid w-full grid-cols-12 border-b pb-3">
                    <h6 className="text-neutral-tones-text font-inter-variable col-span-4 text-xl font-bold">
                      Question
                    </h6>
                    <h6 className="text-neutral-tones-text font-inter-variable col-span-4 text-xl font-bold">
                      Question Type
                    </h6>
                    <h6 className="text-neutral-tones-text font-inter-variable col-span-4 text-xl font-bold">
                      Answer
                    </h6>
                  </div>
                  {formHandler?.values?.otherQuestions?.map(
                    (question: any, index: number) => (
                      <div
                        key={index}
                        className="border-neutral-tones-text/10 mt-3 grid w-full grid-cols-12 border-b pb-3"
                      >
                        <p className="text-neutral-tones-text font-inter-variable col-span-4 truncate text-base font-normal capitalize">
                          {question?.question}
                        </p>
                        <p className="text-neutral-tones-text font-inter-variable col-span-4 text-base font-normal">
                          {question?.questionType}
                        </p>

                        <div className="col-span-4 flex items-center justify-between">
                          <p
                            title={question?.answer}
                            className="text-neutral-tones-text font-inter-variable truncate text-base font-normal"
                          >
                            {question?.answer}
                          </p>
                          <div className="flex items-center gap-15">
                            <button
                              type="button"
                              onClick={() => {
                                setSelectedQuestion({ ...question, index });
                                dispatch(
                                  toggleModal('investigation-new-question'),
                                );
                              }}
                              className="cursor-pointer"
                            >
                              <EditIcon className="[&>path]:fill-brand-byzantine h-5 w-5" />
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setSelectedQuestion(question);
                                dispatch(toggleModal('delete-question'));
                              }}
                              className="group cursor-pointer"
                            >
                              <SidebarCrossIcon className="[&>g>path]:fill-neutral-tones-text/50 group-hover:[&>g>path]:fill-brand-posh-pink h-5 w-5" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ),
                  )}
                  <Button
                    variant="primary"
                    size="smaller"
                    type="button"
                    onClick={() =>
                      dispatch(toggleModal('investigation-new-question'))
                    }
                    otherClasses="mt-4"
                  >
                    <PlusIcon className="h-5 w-5 [&>path]:fill-current" />
                    Add Question
                  </Button>
                </div>
              </div>
            ) : (
              <>
                <p className="font-inter-variable text-neutral-tones-text text-sm leading-4 font-normal lg:text-xl lg:leading-6">
                  Would you like to create more questions to add context to this
                  report?
                </p>
                <Button
                  type="button"
                  variant="link"
                  onClick={() =>
                    dispatch(toggleModal('investigation-new-question'))
                  }
                  otherClasses="!text-lg !font-bold !text-brand-byzantine "
                >
                  <PlusIcon className="h-5 w-5 [&>path]:fill-current" />
                  Add Question
                </Button>
              </>
            )}
          </div>
        )}
      </div>
      <div className="">
        <h6 className="text-brand-papery font-inter-variable text-base leading-5 font-bold uppercase lg:text-xl lg:leading-6">
          ROOT CAUSE ANALYSIS
        </h6>
        <TextArea
          label="Based on the questions you have just answered, what do you think is the most likely root cause?"
          name="rootCauseAnalysis"
          value={formHandler.values.rootCauseAnalysis}
          onChange={(e) =>
            formHandler.setFieldValue('rootCauseAnalysis', e.target.value)
          }
          placeholder="I think that....."
          otherClasses={{
            container: 'w-full max-w-864 mt-2.5 mb-9',
            label:
              'font-inter-variable text-neutral-tones-text text-sm leading-4 lg:leading-6 lg:text-xl font-normal',
          }}
          errorMessage={
            formHandler?.touched.rootCauseAnalysis &&
            formHandler?.errors.rootCauseAnalysis
              ? formHandler?.errors.rootCauseAnalysis
              : ''
          }
          onBlur={() => formHandler?.setFieldTouched('rootCauseAnalysis', true)}
        />
        <p className="font-inter-variable text-neutral-tones-text text-sm leading-4 font-normal lg:text-xl lg:leading-6">
          Thank you for answering all the questions. This will allow us to make
          [WORKPLACE] safer and better for everyone.
        </p>
      </div>
      <div className="mt-9 flex items-center gap-8">
        <Button
          size={sm}
          otherClasses="w-full sm:w-185"
          variant="secondary"
          type="button"
          onClick={() =>
            handleNextStep(
              formHandler?.values?.files?.length > 0 || attachments?.length > 0
                ? 2
                : questions.length > 0
                  ? 3
                  : 2,
            )
          }
        >
          <ChevronIcon className="h-6 w-6 rotate-90 [&>path]:fill-current" />
          Go Back
        </Button>
        <Button
          size={sm}
          otherClasses="w-full sm:w-185"
          type="button"
          onClick={() => handleNextStep(5)}
        >
          Review
          <ChevronIcon className="h-6 w-6 -rotate-90 [&>path]:fill-current" />
        </Button>
      </div>

      {['investigation-new-question', 'delete-question'].includes(
        modalName,
      ) && (
        <ModalComponent
          otherClasses="px-4 py-4"
          additionalClass={clsx(
            ' h-fit max-h-full w-full p-5 lg:px-9 lg:py-6  rounded-2xl',
            'max-w-573',
          )}
          customClose={() => {
            dispatch(toggleModal(''));
            setSelectedQuestion(null);
          }}
        >
          {modalName === 'investigation-new-question' && (
            <InvestigationReportingAddQuestionModal
              formHandler={formHandler}
              selectedQuestion={selectedQuestion}
              handleClose={() => {
                dispatch(toggleModal(''));
                setSelectedQuestion(null);
              }}
            />
          )}
          {modalName === 'delete-question' && (
            <InvestigationReportingDeleteQuestionModal
              question={selectedQuestion}
              handleClose={() => {
                dispatch(toggleModal(''));
                setSelectedQuestion(null);
              }}
              handleDeleteQuestion={() => {
                formHandler.setFieldValue(
                  'otherQuestions',
                  formHandler.values.otherQuestions?.filter(
                    (q: any) => q !== selectedQuestion,
                  ),
                );
                dispatch(toggleModal(''));
                setSelectedQuestion(null);
              }}
            />
          )}
        </ModalComponent>
      )}
    </div>
  );
};

export default InvestigationReportingStepFour;
